import React, { Component } from 'react'
import { MuiGrid, MuiTypography, MuiInputBase, MuiButton, MuiTextField, MuiToolTip } from '../../../../../ui/MaterialUIComponents'
import { ExpansionPanel, ExpansionPanelSummary, ExpansionPanelDetails } from '@material-ui/core'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import * as StringReplacer from '../../../../../../i18n/StringReplacer'
import { DialogComponentUtil } from '..';
import Autocomplete from '@material-ui/lab/Autocomplete';
import theme from '../../../../../../assests/theme'

import spinner from "../../../../../ui/icons/spinner.gif";
class RequiredSharedRoomForElectives extends Component {
  render() {
    const { i18n } = this.props
    return (
      <React.Fragment>
        <MuiGrid>
          <MuiGrid container style={{ marginBottom: "2%" }} >
            <MuiGrid item xs={12}>
              {this.props.elective.subjects.map((subject, index) =>

                <ExpansionPanel >
                  <ExpansionPanelSummary
                    // onClick={() => this.props.showTeachersAndTAs(subject)}
                    expandIcon={<ExpandMoreIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                  >
                    <MuiGrid container>
                      <MuiToolTip
                        placement="top-start"
                        title={StringReplacer.getFormatedMessage(i18n.requiredSharedRoomForElective.heading,
                          {
                            Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
                            Subject: subject.name,
                            Grades: DialogComponentUtil.getToolTipString(this.props),
                          })
                        } >
                        <MuiTypography style={theme.typography.h6} gutterBottom>
                          {StringReplacer.getFormatedMessage(i18n.requiredSharedRoomForElective.heading,
                            {
                              Elective: DialogComponentUtil.getSubjectsForTemplate(this.props),
                              Subject: subject.name,
                              Grades: DialogComponentUtil.getGradeForTemplate(this.props),
                            })
                          }
                        </MuiTypography>
                      </MuiToolTip>
                    </MuiGrid>
                  </ExpansionPanelSummary>
                  <ExpansionPanelDetails>
                    <MuiGrid container xs={10} >
                      <MuiGrid container xs={12} justify="center"
                        style={theme.tableHeaderStyle}
                      >
                        <MuiTypography style={theme.tableHeaderTextStyle}>
                          Available Rooms
            </MuiTypography>
                      </MuiGrid>
                      <MuiGrid container xs={12} style={theme.gridTableSelectStyle}>
                        <Autocomplete
                          id="combo-box-demo"
                          multiple
                          defaultValue={this.props.sharedRoomsForElective.subjects[index].rooms}
                          options={this.props.school_sharedRooms}
                          getOptionLabel={option => option.name}
                          style={{ width: 500 }}
                          onChange={(event, value) => { this.props.handleChangeNameforElective(event, value, index) }}
                          renderInput={params => (
                            <MuiTextField
                              {...params}
                              fullWidth
                              InputProps={{ ...params.InputProps, disableUnderline: true }}
                            />)}
                        />
                      </MuiGrid>
                    </MuiGrid>
                  </ExpansionPanelDetails>
                </ExpansionPanel>)}
            </MuiGrid>
          </MuiGrid>
        </MuiGrid>
        <MuiGrid container justify="flex-end" style={{ marginTop: "10px", paddingTop: "10px", borderTop: "1px solid " + theme.palette.grey.main }}>
          <MuiGrid item style={{ marginRight: "10px" }}>
            <MuiButton style={theme.secondaryButtonStyle} onClick={this.props.handleCloseForDialog}>
              Cancel
                    </MuiButton>
          </MuiGrid>
          <MuiGrid item>
            {this.props.updateSchoolinformationInProgress ? <img src={spinner} alt="none" style={theme.spinnerImgStyleForButton} /> :
              <MuiButton disabled={this.props.disableEdit} style={this.props.disableEdit ? theme.primaryButtonDisabledStyle : theme.primaryButtonStyle} onClick={() => this.props.onClickOfSaveForElective()}>
                Save
                    </MuiButton>}
          </MuiGrid>
        </MuiGrid>
      </React.Fragment>
    )
  }
}

export default RequiredSharedRoomForElectives
